import { ApiError } from 'api/schema/core/ApiError'
import { format, parseISO } from 'date-fns'
import type { NormalizedStatisticsApiRow } from 'features/tasksNormalized/filterableRecord'
import type { TFunction } from 'i18next'

export function isGausiumTaskReportRow(vendorOriginRecordType: string | null | undefined): boolean {
  return vendorOriginRecordType === 'gausium_task_report'
}

export function reportOpenErrorMessage(err: unknown, t: TFunction): string {
  if (err instanceof ApiError) {
    const b = err.body
    if (b && typeof b === 'object' && !Array.isArray(b)) {
      const o = b as Record<string, unknown>
      if (typeof o.detail === 'string' && o.detail.trim()) return o.detail
      if (typeof o.error === 'string' && o.error.trim()) return o.error
    }
    if (err.status === 502)
      return t('robot.history_report_error_upstream', 'Gausium could not generate the report (service error).')
    if (err.status === 404) return t('robot.history_report_error_not_found', 'Robot or report was not found.')
    if (err.status === 403) return t('robot.history_report_error_forbidden', 'You do not have access to this robot.')
  }
  return t('robot.history_report_error_generic', 'Could not open report. Try again later.')
}

function safeParseDate(s: string | undefined | null): Date | null {
  if (!s) return null
  try {
    const d = parseISO(String(s).replace(' ', 'T'))
    return Number.isNaN(d.getTime()) ? null : d
  } catch {
    return null
  }
}

export function gausiumTaskReportPngFilename(startAt: Date | string | null | undefined): string {
  const parsed = startAt instanceof Date ? startAt : safeParseDate(typeof startAt === 'string' ? startAt : null)
  if (parsed) {
    return `task-report-${format(parsed, 'yyyy-MM-dd_HH-mm-ss')}.png`
  }
  return 'task-report.png'
}

export function gausiumReportParamsFromRow(row: NormalizedStatisticsApiRow): {
  robotSn: string
  reportId: string
  startAt: Date | null
} {
  return {
    robotSn: String(row.robot_sn ?? '').trim(),
    reportId: String(row.vendor_origin_record_id ?? row.event_id ?? '').trim(),
    startAt: safeParseDate(row.start_time || row.created_at),
  }
}
